<ng-template #fieldComponent> </ng-template>
<small [id]="id + '-description'" class="form-text" [ngClass]="props.customDescription?.class">
  {{ description | translate : args }}
</small>
